import { loadDisableAds } from "@/common/utils/storage";

export const isDisableAds = () => {
  if (location.search.includes("disable_ads=yes")) {
    return true;
  }

  return loadDisableAds() === "yes";
};
